module.exports = __webpack_public_path__ + "img/about_hakuna.aec603e4.jpg";